import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_DigitalIDActivations } from "../../shared/data.service";

@Component({
	selector: "app-did-add-schools",
	templateUrl: "./did-add-schools.component.html",
	styleUrls: ["./did-add-schools.component.css"],
})
export class DIdAddSchoolsComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private DigitalIDActivationService: DataService_DigitalIDActivations,
		private dialogConfig: DynamicDialogConfig
	) {}

	ngOnInit(): void {
		//Get Data from DB
		this.loadSchoolist();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	loading: boolean = false;
	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolist() {
		this.loading = true;

		var result = this.DigitalIDActivationService.ActivationInsertSchoolSelectList();
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.UpdateSelected();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	UpdateSelected() {
		this.SelectedSchools = this.dialogConfig.data.SelectedSchools;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedSchools);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
